{
  "oneUpgrade": {
    "insufficientAviosPage": {
      "heading": "Not enough Avios or benefits",
      "notificationText": "You don't have enough Avios or upgrade benefits to join the waitlist yet. You can buy more Avios to join now, or come back 30 days before departure to check for cash upgrades if available.",
      "tableFlightsHeader": "Flights",
      "tableRequiredAviosHeader": "Required Avios",
      "ctaLabel": "Buy more Avios",
      "ctaHref": "https://www.finnairshop.com/en/buy-avios",
      "upgradeNotAvailable": "Upgrade not available"
    },
    "errorPageReturnButtonLabel": "Try another booking"
  }
}
